<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div fxLayout="column" id="itemRecordContainer">
  <div *ngFor="let item of record.formElements">
    <div [ngSwitch]="item.elementType">
      <div *ngSwitchCase="FormElementType.TEXT" id="recordTextElement">
        <record-text [text]="item.elementRecord.displayedText"></record-text>
      </div>
      <div *ngSwitchCase="FormElementType.TEXTFIELD" id="recordTextfieldElement">
        <record-icon-text
          [text]="item.elementRecord.label"
          [icon]="faSquarePen"
          class="element-header"
        ></record-icon-text>
        <div class="element-value">
          <record-icon-text
            [text]="item.elementRecord.inputValue"
            [icon]="item.elementRecord.icon"
            [linkType]="getLinkType(item.elementRecord.inputType)"
          ></record-icon-text>
        </div>
      </div>
      <div *ngSwitchCase="FormElementType.CHECKBOX" id="recordCheckboxElement">
        <record-icon-text
          [text]="item.elementRecord.displayedText"
          [icon]="item.elementRecord.isSelected ? faCheckSquare : faSquare"
        ></record-icon-text>
      </div>
      <div *ngSwitchCase="FormElementType.RADIOGROUP" id="recordRadioGroupElement">
        <record-icon-text
          [text]="item.elementRecord.displayedText"
          [icon]="faListRadio"
          class="element-header"
        ></record-icon-text>

        <div
          fxLayout="row"
          *ngFor="let option of item.elementRecord.options; let i = index"
          class="element-value"
        >
          <record-icon-text
            [text]="option.optionText"
            [icon]="option.isSelected ? faCircleDot : faCircle"
          ></record-icon-text>
        </div>
      </div>
      <div *ngSwitchCase="FormElementType.DROPDOWN" id="recordDropdownElement">
        <record-icon-text
          [text]="item.elementRecord.displayedText"
          [icon]="faListDropdown"
          class="element-header"
        ></record-icon-text>

        <div
          fxLayout="row"
          *ngFor="let option of item.elementRecord.options; let i = index"
          class="element-value"
        >
          <ng-container *ngIf="option.isSelected; else unselectedOption">
            <record-icon-text [text]="option.optionText" [icon]="faCheck"></record-icon-text>
          </ng-container>
          <ng-template #unselectedOption>
            <record-text [text]="option.optionText" id="unselectedDropdownOption"></record-text>
          </ng-template>
        </div>
      </div>
      <div *ngSwitchCase="FormElementType.IMAGE" id="recordImageElement">
        <record-icon-text
          [text]="item.elementRecord.text"
          [icon]="faImage"
          class="element-header"
        ></record-icon-text>
        <div class="image-element">
          <record-image [images]="[item.elementRecord.image]"></record-image>
        </div>
      </div>
    </div>
  </div>
</div>
